import { render, staticRenderFns } from "./FGDataSelect.vue?vue&type=template&id=0d75a09c&scoped=true"
import script from "./FGDataSelect.vue?vue&type=script&lang=js"
export * from "./FGDataSelect.vue?vue&type=script&lang=js"
import style0 from "./FGDataSelect.vue?vue&type=style&index=0&id=0d75a09c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d75a09c",
  null
  
)

export default component.exports